import axios from "axios";
import apiConfig from "../config/appConfig";
import { useNavigate } from "react-router-dom";

const axiosInstance = axios.create({
  baseURL: apiConfig.baseURL,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem("token"); // Clear the token
      window.location.href = "/"; // Redirect to login page
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
